type NotificationCenterRouteTab = "upcoming" | "recent";

let baseUrl = "";

export const setRoutingBaseUrl = (url: string) => {
	baseUrl = url;
};

export const Routing = {
	ActivitiesList: {
		path: () => `${baseUrl}/activities`,
	},
	ActivityDetail: {
		route: `${baseUrl}/activities/:id`,
		path: (id: string) => `${baseUrl}/activities/${id}`,
	},
	TaskDetail: {
		route: `${baseUrl}/tasks/:id`,
		path: (id: string) => `${baseUrl}/tasks/${id}`,
	},
	Portfolio: {
		PortfolioTabs: {
			path: () => `${baseUrl}/portfolio`,
		},
		PortfolioList: {
			path: () => `${baseUrl}/portfolio/portfolios`,
		},
		DocumentsList: {
			path: () => `${baseUrl}/portfolio/documents`,
		},
		PortfolioFilter: {
			path: () => `${baseUrl}/portfolio/filter`,
		},
		PortfolioAddItem: {
			path: () => `${baseUrl}/portfolio/add`,
		},
		PortfolioAddCar: {
			path: () => `${baseUrl}/portfolio/add/car`,
		},
		PortfolioAddCarSuccess: {
			path: () => `${baseUrl}/portfolio/add/car/success`,
		},
		PortfolioEditCar: {
			route: `${baseUrl}/portfolio/car/:id/edit`,
			path: (id: number) => `${baseUrl}/portfolio/car/${id}/edit`,
		},
		PortfolioAddArt: {
			path: () => `${baseUrl}/portfolio/add/art`,
		},
		PortfolioAddArtSuccess: {
			path: () => `${baseUrl}/portfolio/add/art/success`,
		},
		PortfolioEditArt: {
			route: `${baseUrl}/portfolio/art/:id/edit`,
			path: (id: number) => `${baseUrl}/portfolio/art/${id}/edit`,
		},
		PortfolioAddBuildingSavings: {
			path: () => `${baseUrl}/portfolio/add/building-savings`,
		},
		PortfolioAddBuildingSavingsSuccess: {
			path: () => `${baseUrl}/portfolio/add/building-savings/success`,
		},
		PortfolioEditBuildingSavings: {
			route: `${baseUrl}/portfolio/building-savings/:id/edit`,
			path: (id: number) => `${baseUrl}/portfolio/building-savings/${id}/edit`,
		},
		PortfolioAddServices: {
			path: () => `${baseUrl}/portfolio/add/services`,
		},
		PortfolioAddServicesSuccess: {
			path: () => `${baseUrl}/portfolio/add/services/success`,
		},
		PortfolioEditServices: {
			route: `${baseUrl}/portfolio/services/:id/edit`,
			path: (id: number) => `${baseUrl}/portfolio/services/${id}/edit`,
		},
		PortfolioAddLifeInsurance: {
			path: () => `${baseUrl}/portfolio/add/life-insurance`,
		},
		PortfolioAddLifeInsuranceSuccess: {
			path: () => `${baseUrl}/portfolio/add/life-insurance/success`,
		},
		PortfolioEditLifeInsurance: {
			route: `${baseUrl}/portfolio/life-insurance/:id/edit`,
			path: (id: number) => `${baseUrl}/portfolio/life-insurance/${id}/edit`,
		},
		PortfolioAddInvestment: {
			path: () => `${baseUrl}/portfolio/add/investment`,
		},
		PortfolioAddInvestmentSuccess: {
			path: () => `${baseUrl}/portfolio/add/investment/success`,
		},
		PortfolioEditInvestment: {
			route: `${baseUrl}/portfolio/investment/:id/edit`,
			path: (id: number) => `${baseUrl}/portfolio/investment/${id}/edit`,
		},
		PortfolioAddPension: {
			path: () => `${baseUrl}/portfolio/add/pension`,
		},
		PortfolioAddPensionSuccess: {
			path: () => `${baseUrl}/portfolio/add/pension/success`,
		},
		PortfolioEditPension: {
			route: `${baseUrl}/portfolio/pension/:id/edit`,
			path: (id: number) => `${baseUrl}/portfolio/pension/${id}/edit`,
		},
		PortfolioAddBankProduct: {
			path: () => `${baseUrl}/portfolio/add/bank-product`,
		},
		PortfolioAddBankProductSuccess: {
			path: () => `${baseUrl}/portfolio/add/bank-product/success`,
		},
		PortfolioEditBankProduct: {
			route: `${baseUrl}/portfolio/bank-product/:id/edit`,
			path: (id: number) => `${baseUrl}/portfolio/bank-product/${id}/edit`,
		},
		PortfolioAddLeasing: {
			path: () => `${baseUrl}/portfolio/add/leasing`,
		},
		PortfolioAddLeasingSuccess: {
			path: () => `${baseUrl}/portfolio/add/leasing/success`,
		},
		PortfolioEditLeasing: {
			route: `${baseUrl}/portfolio/leasing/:id/edit`,
			path: (id: number) => `${baseUrl}/portfolio/leasing/${id}/edit`,
		},
		PortfolioAddBusinessLoans: {
			path: () => `${baseUrl}/portfolio/add/business-loans`,
		},
		PortfolioAddBusinessLoansSuccess: {
			path: () => `${baseUrl}/portfolio/add/business-loans/success`,
		},
		PortfolioEditBusinessLoans: {
			route: `${baseUrl}/portfolio/business-loans/:id/edit`,
			path: (id: number) => `${baseUrl}/portfolio/business-loans/${id}/edit`,
		},
		PortfolioAddCryptocurrency: {
			path: () => `${baseUrl}/portfolio/add/cryptocurrency`,
		},
		PortfolioAddCryptocurrencySuccess: {
			path: () => `${baseUrl}/portfolio/add/cryptocurrency/success`,
		},
		PortfolioEditCryptocurrency: {
			route: `${baseUrl}/portfolio/cryptocurrency/:id/edit`,
			path: (id: number) => `${baseUrl}/portfolio/cryptocurrency/${id}/edit`,
		},
		PortfolioAddCommodities: {
			path: () => `${baseUrl}/portfolio/add/commodities`,
		},
		PortfolioAddCommoditiesSuccess: {
			path: () => `${baseUrl}/portfolio/add/commodities/success`,
		},
		PortfolioEditCommodities: {
			route: `${baseUrl}/portfolio/commodities/:id/edit`,
			path: (id: number) => `${baseUrl}/portfolio/commodities/${id}/edit`,
		},
		PortfolioAddLandSuccess: {
			path: () => `${baseUrl}/portfolio/add/land/success`,
		},
		PortfolioEditLand: {
			route: `${baseUrl}/portfolio/land/:id/edit`,
			path: (id: number) => `${baseUrl}/portfolio/land/${id}/edit`,
		},
		PortfolioAddRealEstate: {
			path: () => `${baseUrl}/portfolio/add/real-estate`,
		},
		PortfolioAddRealEstateSuccess: {
			path: () => `${baseUrl}/portfolio/add/real-estate/success`,
		},
		PortfolioEditRealEstate: {
			route: `${baseUrl}/portfolio/real-estate/:id/edit`,
			path: (id: number) => `${baseUrl}/portfolio/real-estate/${id}/edit`,
		},
		PortfolioDetail: {
			route: `${baseUrl}/portfolio/:id`,
			path: (id: string) => `${baseUrl}/portfolio/${id}`,
		},
		PropertyDetail: {
			route: `${baseUrl}/property/:id`,
			path: (id: string) => `${baseUrl}/property/${id}`,
		},
		PortfolioDetailHistory: {
			route: `${baseUrl}/portfolio/:id/history/:toolId`,
			path: (id: number, toolId: number) =>
				`${baseUrl}/portfolio/${id}/history/${toolId}`,
		},
		FolderDetail: {
			route: `${baseUrl}/portfolio/folder/:tag`,
			path: (tag: string) => `${baseUrl}/portfolio/folder/${tag}`,
		},
	},
	Profile: {
		ProfileDetail: {
			path: () => `${baseUrl}/profile`,
		},
		PersonalDataAndAccounts: {
			path: () => `${baseUrl}/profile/personal-data-and-accounts`,
		},
		Addresses: {
			path: () => `${baseUrl}/profile/addresses`,
		},
		Paperwork: {
			path: () => `${baseUrl}/profile/paperwork`,
		},
		More: {
			path: () => `${baseUrl}/profile/more`,
		},
		Security: {
			path: () => `${baseUrl}/profile/security`,
		},
		Settings: {
			path: () => `${baseUrl}/profile/settings`,
		},
		NotificationSettings: {
			path: () => `${baseUrl}/profile/notification-settings`,
		},
	},
	Dashboard: {
		path: () => "/dashboard",
	},
	Notifications: {
		path: (tab?: NotificationCenterRouteTab) =>
			tab ? `${baseUrl}/notifications?tab=${tab}` : `${baseUrl}/notifications`,
	},
	NotificationsUnread: {
		path: () => `${baseUrl}/notifications/unread`,
	},
	NotificationsAll: {
		path: () => `${baseUrl}/notifications/all`,
	},
	NotificationsFilter: {
		path: () => `${baseUrl}/notifications/filter`,
	},
	Advisor: {
		path: () => `${baseUrl}/advisor`,
	},
	Chat: {
		List: {
			path: () => `${baseUrl}/chat`,
		},
		Detail: {
			route: `${baseUrl}/chat/:conversationId`,
			path: (conversationId: string, advisorId?: string) =>
				`${baseUrl}/chat/${conversationId}${
					advisorId ? `?advisorId=${encodeURIComponent(advisorId)}` : ""
				}`,
		},
	},
	Finances: {
		Intro: {
			path: () => `${baseUrl}/finances/intro`,
		},
		Income: {
			path: () => `${baseUrl}/finances/income`,
		},
		Expenses: {
			path: () => `${baseUrl}/finances/expenses`,
		},
		Balance: {
			path: () => `${baseUrl}/finances/balance`,
		},
		Overview: {
			path: () => `${baseUrl}/finances/overview`,
		},
	},
	Goals: {
		GoalsList: {
			path: () => `${baseUrl}/goals`,
		},
		GoalFormCreate: {
			path: () => `${baseUrl}/goals/new`,
		},
		GoalFormEdit: {
			route: `${baseUrl}/goals/:id/edit`,
			path: (id: number) => `${baseUrl}/goals/${id}/edit`,
		},
		GoalDetail: {
			route: `${baseUrl}/goals/:id`,
			path: (id: string) => `${baseUrl}/goals/${id}`,
		},
	},
	DashboardDetail: {
		route: `${baseUrl}/dashboard/:type`,
		path: (type: string) => `${baseUrl}/dashboard/${type}`,
	},
	Inspiration: {
		Detail: {
			route: `${baseUrl}/inspiration/:id`,
			path: (id: string) => `${baseUrl}/inspiration/${id}`,
		},
	},
	StandAlone: {
		path: () => "/myplann-portfolio-standalone/portfolio",
	},
} as const;
